import Vue from 'vue'
import App from './App.vue'
// import './assets/css/fonts.css'
import './assets/css/common.css'
import './assets/css/style.css'
import './assets/css/cartographie.css'
import './assets/css/home.css'
import './assets/css/menu.css'
import './assets/css/header.css'
import './assets/css/list.css'
import './assets/css/modal.css'
import Notifications from 'vue-notification'
import velocity from 'velocity-animate'

import router from './router'
import store from './store'
Vue.use(Notifications, {
  velocity
})
Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  bus: new Vue(),
  router,
  store,
  components: {
    App
  },
  created: function() {
    document.title = 'ANFR - PRTV Antenniste';
  }

}).$mount('#app')
